module.exports = __webpack_public_path__ + "img/slide-7.1b6bd0d9.png";